import React from 'react'
import styled from 'styled-components'
import { mixinInputForm } from 'spa/member/styles/mixin'
import { useFormContext, Controller } from 'react-hook-form'
import AlertIcon from 'images/alert_icon.svg'

export type Props = {
  name: string,
  options: OptionType[],
  rules?: any,
} & React.SelectHTMLAttributes<HTMLSelectElement>

export type OptionType = {
  label: string,
  value: string,
}

const StyledSelectBoxContainer = styled.div`
  position: relative;
  &::after {
    content: "";
    position: absolute;
    right: 12px;
    top: 50%;
    width: 8px;
    height: 8px;
    border-top: 2px solid ${props => props.theme.members.colors.silver._70};
    border-left: 2px solid ${props => props.theme.members.colors.silver._70};
    transform: translateY(-75%) rotate(-135deg);
    font-size: 20px;
    pointer-events: none;
  }
`

const StyledSelectBox = styled.select<{ hasError?: boolean }>`
  appearance: none;
  ${mixinInputForm}
  height: 3rem;

  padding: .75rem .75rem .75rem 1rem;
  background-color: ${props => props.hasError ? '#FFEDED' : props.theme.members.colors.white};  color: ${props => props.theme.members.colors.black._100};
  border: 1px solid ${props => props.hasError ? '#D52020' : props.theme.members.colors.silver._70};

  @media ${props => props.theme.media.md} {
    padding: 1rem;
  }
`

const ErrorMessage = styled.span`
  color: #F15252;
  font-size: 0.875rem;
  margin-top: 4px;
  display: block;
`

export const StyledSelect: React.FC<Props> = (props: Props) => {
  const { control, formState: { errors } } = useFormContext()

  return (
    <StyledSelectBoxContainer>
      <Controller
        name={props.name}
        control={control}
        rules={props.rules}
        render={({ field }) => (
          <>
            <StyledSelectBox
              {...field}
              {...props}
              hasError={!!errors[props.name]}
              onChange={(e) => {
                field.onChange(e);
                props.onChange && props.onChange(e)}}
            >
              {props.options.map((option: OptionType, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </StyledSelectBox>
            {errors[props.name] && (
              <ErrorMessage>
                <img className="inline" src={AlertIcon} alt="alert" />
                {errors[props.name].message}
              </ErrorMessage>
            )}
          </>
        )}
      />
    </StyledSelectBoxContainer>
  )
}
